import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const brands = [
  {
    title: 'materiaux_bp_title',
    desc: 'materiaux_bp_desc',
    icon: 'ri-building-3-line',
    image: 'https://readdy.ai/api/search-image?query=stack%20of%20BP%20Canada%20asphalt%20roofing%20shingles%20on%20a%20wooden%20pallet%20in%20a%20construction%20supply%20warehouse%20professional%20product%20photography%20soft%20neutral%20background%20warm%20copper%20lighting%20high%20quality%20sharp%20focus&width=400&height=300&seq=refmat1&orientation=landscape',
    alt: "Bardeaux d'asphalte BP Canada pour réfection toiture Lévis",
  },
  {
    title: 'materiaux_iko_title',
    desc: 'materiaux_iko_desc',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=premium%20IKO%20architectural%20asphalt%20shingles%20samples%20displayed%20on%20a%20wooden%20surface%20showing%20texture%20and%20color%20variations%20professional%20product%20photography%20warm%20lighting%20neutral%20background%20high%20quality&width=400&height=300&seq=refmat2&orientation=landscape',
    alt: "Bardeaux haut de gamme IKO pour toiture résidentielle à Lévis",
  },
  {
    title: 'materiaux_soprema_title',
    desc: 'materiaux_soprema_desc',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Soprema%20elastomeric%20membrane%20roll%20being%20installed%20on%20a%20flat%20residential%20roof%20by%20a%20professional%20roofer%20showing%20the%20black%20rubber%20membrane%20and%20heat%20welding%20process%20professional%20photography%20daylight%20warm%20tones&width=400&height=300&seq=refmat3&orientation=landscape',
    alt: "Membrane élastomère Soprema installation toit plat Lévis",
  },
];

export default function Materiaux() {
  const { t } = useTranslation('refection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="materiaux" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-10 md:mb-14 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            {t('materiaux_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {brands.map((brand, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl border border-soft-dark overflow-hidden hover:border-copper/40 transition-all duration-500 group ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className="h-48 md:h-52 overflow-hidden">
                <img
                  src={brand.image}
                  alt={`${brand.alt} — couvreur RBQ à Lévis`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                  width="400"
                  height="300"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-copper/15">
                    <i className={`${brand.icon} text-copper text-lg`} />
                  </span>
                  <h3 className="font-manrope font-bold text-slate-primary text-base md:text-lg">
                    {t(brand.title)}
                  </h3>
                </div>
                <p className="text-slate-primary/60 text-sm leading-relaxed">
                  {t(brand.desc)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p
          className={`text-center text-slate-primary/50 text-xs md:text-sm mt-8 transition-all duration-1000 delay-500 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          {t('materiaux_note')}
        </p>
      </div>
    </section>
  );
}